module.exports = __webpack_public_path__ + "static/img/home_safeguard.7cb920a5.svg";